export default __webpack_public_path__ + "static/media/f_username.27f9b187.svg";